export const parseJSON = (str: string | null) => {
  try {
    return str ? JSON.parse(str) : false;
  } catch (e) {
    return false;
  }
};
